import RecaptchaInfo from '@type/inline/RecaptchaInfo';
import { serialize } from 'object-to-formdata';
import { Dispatch, SetStateAction } from 'react';
import recaptchaVerificationThresholdScore from '@functions/recaptchaVerificationThresholdScore/recaptchaVerificationThresholdScore';

declare const grecaptcha;

declare const recaptchaInfo: RecaptchaInfo;

type Props = {
    setVerifying: Dispatch<SetStateAction<boolean>>;
    setRecaptchaError: Dispatch<SetStateAction<boolean>>;
    successFunction: () => Promise<void>;
    byPass?: boolean;
};

const onSubmitRecaptchaVerification = async ({
    setVerifying,
    setRecaptchaError,
    successFunction,
    byPass = false,
}: Props) => {
    if (
        (window['environment']['name'] === 'production' ||
            window['environment']['name'] === 'staging' ||
            window['environment']['name'] === 'development') &&
        byPass === false
    ) {
        console.log('this is production/staging');
        grecaptcha.ready(async () => {
            setVerifying(true);
            const response = await grecaptcha.execute(recaptchaInfo.key, { action: 'verify_form_fill' });
            const token = await response;
            const verificationBody = {
                g_recaptcha_response: token,
            };
            const verificationData = serialize(verificationBody);

            const verificationRequest = await fetch('/wp-json/tb/v1/recaptcha-verification', {
                method: 'POST',
                body: verificationData,
                redirect: 'follow',
            });

            const verificationResponse = await verificationRequest.json();

            if (
                verificationResponse.success === true &&
                verificationResponse.score >= recaptchaVerificationThresholdScore() &&
                verificationResponse.action === 'verify_form_fill'
            ) {
                console.log(verificationResponse.success);
                console.log(verificationResponse.score);
                successFunction();
            } else if (verificationResponse.success === false) {
                successFunction();
            } else {
                setVerifying(false);
                setRecaptchaError(true);
            }
        });
    } else {
        console.log('this is local/dev');
        await successFunction();
    }
};

export default onSubmitRecaptchaVerification;
